import { render, staticRenderFns } from "./unordered-list.vue?vue&type=template&id=9f13adc8&"
import script from "./unordered-list.vue?vue&type=script&lang=js&"
export * from "./unordered-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports